import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";

import useAddChannel from "./hooks/useAddChannel";
import useChannel from "./hooks/useChannel";
import { useRecoilState } from "recoil";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import { addStateChannel, setFilterTextChannel } from "./atoms/atoms";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import { useQueryClient } from "react-query";

const ChannelForm = () => {
  //Hooks
  const { mutateAsync: AddChannel } = useAddChannel();
  const { data } = useChannel();
  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateChannel);
  const [filterText, setFilterText] = useRecoilState(setFilterTextChannel);
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasChannel, setHasChannel] = useState(false);
  const queryClient = useQueryClient();

  const defaultValues = {
    channelId: 0,
    channelName: "",
  };
  const [emptypeNewData, setNewData] = useState([defaultValues]);
  const [channelExist, setChannelExist] = useState(false);

  const handleAddChannel = (SourceType, fieldName, inputvalue) => {
    setChanged(true);
    setChannelExist(false);
    inputvalue = inputvalue.trim();
    if (SourceType === "addChannel") {
      if (fieldName === "channelName") {
        const result = data.filter(
          (item) => item.channelName.toUpperCase() === inputvalue.toUpperCase()
        )[0];
        emptypeNewData.map((x) => (x.channelName = inputvalue));
        inputvalue === "" ? setHasChannel(false) : setHasChannel(true);
      }
    }
  };

  //save changes
  const handleSave = (emptypeNewData) => {
    setOpenModal(false);
    if (actionAddState) {
      AddChannel(emptypeNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModal(false);
          } else {
            setActionAddState(false);
            setNewData([defaultValues]);
            queryClient.invalidateQueries(["GetChannels"]);
            toast.fire("Success", "Channel Added Successfully", "success");
            setOpenModal(false);
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Add Channel", "error");
          queryClient.invalidateQueries(["GetChannels"]);
        },
      });
    }
  };
  // end of saving changes

  const matcolumns = [
    {
      title: "Channel Name",
      field: "channelName",
      render: (rowData) => {
        return (
          <div className="grid-cols-3 grid ">
            <div className="">
              <TextInput
                defaultValue={rowData.channelName}
                onChange={(e) =>
                  handleAddChannel("addChannel", "channelName", e.target.value)
                }
              />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="animate-fade-in-down">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add Channel"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(emptypeNewData);
          }}
        />
        <div className="p-3  space-y-1 border-l-2  border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold">
              Add New Channel
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <SaveButton
                className={`flex items-left shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasChannel ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasChannel}
                onClick={() => setOpenModal(true)}
              />
              <CancelButton
                className="flex items-left text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                onClick={() => {
                  setActionAddState(!actionAddState);
                  setFilterText("");
                }}
              />
            </div>
          </div>

          <div className="mt-2 h-0.5 w-full border-b-2 border-secondary mb-5 "></div>

          <div className="py-1"></div>

          <div className="space-y-5 space-x-2 space-y-20 w-full  ">
            <MaterialExTable
              columns={matcolumns}
              data={emptypeNewData}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="pb-1.5"></div>
        </div>
      </div>
    </div>
  );
};

export default ChannelForm;
